<div class="row area1">
  <div class="col-lg-10 col-lg-offset-1 col-md-12">
    <div class="setting-div">
      <div class="col-md-12">
        <ul>
          <li>
            <a href="javascript:void(0)" role="button" class="edit-icon" (click)="toggle()">
              <i aria-hidden="true"
                class="fa fa-eye fa-lg"
                [class.fa-eye]="showFooter"
                [class.fa-eye-slash]="!showFooter"
              ></i>
              <div class="tooltip">開啟/隱藏</div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>  
